import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { take } from 'rxjs/operators';
import { Order } from '../order.reducer';
import { buildFullDeliverUpdate } from '../order-delivery.util';

@Component({
  selector: 'app-order-actions',
  template: '<div>It works!</div>'
})
export class OrderActionsComponent implements OnInit {
  orders$: Observable<any>;

  constructor(private route: ActivatedRoute, private afs: AngularFirestore) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      if (params.get('action') === 'confirm') {
        this.confirm(params.get('id'));
      }
      if (params.get('action') === 'deliver') {
        this.deliver(params.get('id'));
      }
    });
  }

  private confirm(orderId) {
    this.afs.doc(`orders/${orderId}`).update({ confirmed: true }).then(() => {
      alert('Order successfully marked as confirmed. You can close this browser tab.');
    }).catch(err => {
      console.log(err);
      alert('Order not found.');
    });
  }

  private deliver(orderId) {
    const ref = this.afs.doc<Order>(`orders/${orderId}`);
    ref.get().pipe(take(1)).subscribe({
      next: (doc) => {
        if (!doc.exists) {
          alert('Order not found.');
          return;
        }
        const changes = buildFullDeliverUpdate(doc.data());
        ref.update(changes as Partial<Order>).then(() => {
          alert('Order successfully marked as delivered. You can close this browser tab.');
        }).catch(err => {
          console.log(err);
          alert('Order not found.');
        });
      },
      error: (err) => {
        console.log(err);
        alert('Order not found.');
      }
    });
  }
}
